.container {
  /* Layout */
  width: 90%;
  max-width: 1300px;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
}

.title {
  font-size: 2rem;
  font-weight: 200;
  margin-bottom: 8px;
  color: #333333;
  text-align: center;
}

.intro {
  font-size: 1rem;
  color: #505050;
  margin-bottom: 32px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 200;
  text-align: center;
}
